module.exports = __webpack_public_path__ + "static/media/6c532d1a-ef62-45e8-aef6-3e2cb275fd63_1.e379af3571278b1094c1f8af9a1c947f.24ece428.jpeg";